import React from 'react';
import ServicePage from '../components/ServicePage';
import { getServiceData } from '../data/servicesData';
import { getServiceSEO } from '../utils/serviceSEO';

const BanosVipPage: React.FC = () => {
  const serviceData = getServiceData('banos-portatiles-vip');

  if (!serviceData) {
    return <div>Servicio no encontrado</div>;
  }

  const seoData = getServiceSEO('banos-portatiles-vip', serviceData);

  return (
    <ServicePage
      {...serviceData}
      seoTitle={seoData.title}
      seoDescription={seoData.description}
      seoKeywords={seoData.keywords}
      seoUrl={seoData.url}
      structuredData={seoData.structuredData}
    />
  );
};

export default BanosVipPage;